import { useEffect } from "react";

import { GlobalFooter } from "@/patterns/global-footer/src/index";
import GlobalNavigation from "@/patterns/global-nav/src/index";
import { experiments, useExperimentExposure } from "@/utils/experiment";

import CodeBuildShipSection from "./sections/code-build-ship-try-page";
import CollaborateSection from "./sections/collaborate-try-page";
import EnterpriseSection from "./sections/enterprise-try-page";
import GetTheMostSection from "./sections/get-the-most-try-page";
import HeroSection from "./sections/hero-try-page";
import IdentityAndSecuritySection from "./sections/identity-and-security-try-page";
import PlanAndTrackSection from "./sections/plan-and-track";
import SupportAndFixSection from "./sections/support-and-fix-try-page";

export const TryPageTemplate = () => {
    const [dxpMigrationExposureFired, fireDxpMigrationExposure] =
        useExperimentExposure(experiments.dxpMigrationSoftwarePage);
    useEffect(() => {
        if (!dxpMigrationExposureFired) {
            fireDxpMigrationExposure();
        }
    }, [dxpMigrationExposureFired, fireDxpMigrationExposure]);
    return (
        <div>
            <div>
                <GlobalNavigation
                    isShowTryNowLink={false}
                    tryNowLinkCtaButtonColor="light_grey"
                    productKey="try"
                />
            </div>
            <div>
                <div>
                    {/* Try Page content */}
                    <HeroSection />
                    <PlanAndTrackSection />
                    <SupportAndFixSection />
                    <CollaborateSection />
                    <CodeBuildShipSection />
                    <IdentityAndSecuritySection />
                    <GetTheMostSection />
                    <EnterpriseSection />
                </div>
            </div>
            <GlobalFooter />
        </div>
    );
};
